.az{justify-content:flex-end;}